import React, { useEffect , useState } from 'react';

import Logins from "../components/Login";
import AboutsApp from "../components/Abouts";

export default function Abouts() {
 



    return (
    <>
        <AboutsApp   className="mt-40" />
    </>
  );
}
